var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M14 21v-7h2.4l.4-3H14V9.2c0-.9.2-1.5 1.6-1.5H17V5.1C16.7 5.1 15.7 5 14.6 5c-2.3 0-3.9 1.4-3.9 4v2H8.3v3h2.4v7h3.3z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkFacebook);
export default __webpack_public_path__ + "static/media/link-facebook.899ca63d850cc9481966d6fae9adf65e.svg";
export { ForwardRef as ReactComponent };